export const verifySendCodeDateTime = (sendCodeDateTime, value, secondsToValidate, reSend)  => {
    const oldDateTime = getSendCodeDateTimeItem(value);

    let resp = {
        data: value,
        timer: new Date((secondsToValidate - 1)* 1000).toISOString().substr(14, 5),
        valid: true
    };

    if(oldDateTime && oldDateTime.value === value && reSend === false){
        let diff = sendCodeDateTime - oldDateTime.datetime;
        let seconds = diff/(1000);

        if (seconds < secondsToValidate) {
            resp.timer = new Date((secondsToValidate - seconds)* 1000).toISOString().substr(14, 5);
            resp.valid = (resp.timer  === "00:00") ? true  : false;
            if(resp.valid === true){
                deleteSendCodeDateTimeItem(value);
            }
            return resp;
        }else{
            resp.timer = "00:00";
            resp.valid = true;
            deleteSendCodeDateTimeItem(value);
            return resp;
        }
    }
    
    let obj = {
        value: value,
        datetime: sendCodeDateTime,
        valid: true
    };
    
    storeSendCodeDateTimeItem(obj);
    return resp;   
};

const storeSendCodeDateTimeItem = (newObj) => {
    const ListSendCode = getSendCodeDateTime();
    if (ListSendCode?.length > 0) {
        const objIndex = ListSendCode.findIndex(obj => obj.value === newObj.value);
        if (objIndex > -1) {
            ListSendCode[objIndex] = newObj; 
        } else {
            ListSendCode.push(newObj);
        }
        storeSendCodeDateTime(ListSendCode);
   
        return;
    }
    storeSendCodeDateTime([newObj]); 
}



const getSendCodeDateTimeItem = (value) => {
    const ListSendCode = getSendCodeDateTime();

    if (ListSendCode?.length > 0)  {
        const objIndex = ListSendCode.findIndex(obj => obj.value === value);
        return ListSendCode[objIndex];  
    }
    return null
}

export const deleteSendCodeDateTimeItem = (value) => {
    const ListSendCode = getSendCodeDateTime();

    if (ListSendCode?.length > 0) {
        const objIndex = ListSendCode.findIndex(obj => obj.value === value);
        ListSendCode.splice(objIndex, 1); 
    }
    storeSendCodeDateTime(ListSendCode); 

}

const storeSendCodeDateTime = (array) =>{
    localStorage.setItem("sendCodeDateTime", JSON.stringify(array));
}
    
const getSendCodeDateTime = () => {
    return JSON.parse(localStorage.getItem("sendCodeDateTime"));
}